import { ComponentChild } from 'preact';
import { useState } from 'preact/hooks';
import { useTooltipControlled } from '../hooks/UNSAFE_useTooltip';
import { Placement } from '#UNSAFE_Floating';

type Props = {
  label: string;
  isDisabled: boolean;
  position?: Position;
};

type Position = Omit<Placement, 'center'>;

export const useTabBarItemTooltip = ({
  label,
  isDisabled,
  position
}: Props): {
  tooltipContent: ComponentChild;
  tooltipEventHandlerProps: Record<string, any>;
  onLogicalFocus: (elem: HTMLElement) => void;
  onLogicalBlur: () => void;
} => {
  const [isOpen, setOpen] = useState<boolean>(false);
  const { tooltipProps, tooltipContent } = useTooltipControlled({
    isOpen: isOpen,
    isDisabled,
    position: position,
    focusStrategy: 'logical',
    text: label,
    onToggle: ({ value }) => {
      setOpen(value);
    }
  });
  const { onLogicalFocus, onLogicalBlur, ...tooltipEventHandlerProps } = tooltipProps;

  return { tooltipContent, tooltipEventHandlerProps, onLogicalFocus, onLogicalBlur };
};
